module.exports = __webpack_public_path__ + "img/icon_cart_blue.91ce45c3.svg";